<template>
  <button
    :disabled="!eventSelected || loading"
    class="btn btn-wd btn-fill btn-success"
    @click="runReport"
  >
    Gerar relatório do evento
  </button>
</template>
<script>
import blobUtils from 'blob-util'
import downloadJs from 'downloadjs'
import { flattenObject } from 'src/services/Helper'
import Couchdb from 'src/services/Couchdb'
import { mapGetters } from 'vuex'

export default {
  name: 'events-report',

  props: { eventSelected: {}, csvSeparator: {}, allEvents: {} },

  data () {
    return {
      loading: false,
      event: '',
      tickets: [],
      csvHeaders: {
        customer: {
          'uc': 'UC',
          'cpf': 'CPF',
          'nationalId': 'RG',
          'holder': 'Nome',
          'aka': 'Apelido',
          'phone1': 'Telefones',
          'address.street': 'Logradouro',
          'address.number': 'Numero',
          'address.neighborhood': 'Bairro',
          'address.city': 'Município',
          'address.zip': 'CEP',
          'address.complement': 'Complemento',
          'observartion': 'Observação',
          'nis': 'NIS',
          'createdBy': 'Cliente cadastrado por'
        },
        ticket: {
          'winner': 'Sorteado',
          'documentedAt': 'Data documentação',
          'barcode': 'Código de barra',
          'checkIn': 'Presente',
          'createdBy': 'Ticket gerado por'
        },
        event: {
          'city': 'Município',
          'reference': 'Referência',
          'place': 'Local',
          'startDate': 'Data início',
          'endDate': 'Data fim',
          'dateTimeCeremony': 'Data da cerimônia',
          'numberOfRefigerators': 'Qtd. refrigeradores',
          'drawn': 'Houve sorteio?',
          'createdBy': 'Evento criado por'
        },
        stock: {
          'invoice': 'Nota fiscal',
          'dateInvoice': 'Data de emissão da nota fiscal',
          'invoicePowerCompany': 'Nota fiscal da concessionária',
          'dateInvoicePowerCompany': 'Data de emissão da nota fiscal da concessionária',
          'numberOfRefigerators': 'Quantidade de geladeiras',
          'description': 'Descrição do produto',
          'createdBy': 'Estoque criado por'
        },
        manufacturer: { 'name': 'Fabricante', 'createdBy': 'Criado por' }
      }
    }
  },
  methods: {
    async runReport () {
      this.$emit('progress', { current: 0, total: 0 })
      this.loading = true
      this.resetValues()
      try {
        this.event = await this.getEvent()
        this.event.createdBy = this.usersIdName[this.event.userId]
        this.tickets = await this.getTickets()
        this.getReportEvent()
      } catch (e) {
        console.log(e)
        this.$notify({
          message: 'Ocorreu algum problema ao gerar o relatório. Tente novamente, ou espere alguns minutos para tentar. Se persistir, entre em contato com o suporte.',
          type: 'danger'
        })
      } finally {
        this.loading = false
      }
    },
    getEvent () {
      let select = ['_id', 'city', 'reference', 'place', 'startDate', 'endDate', 'dateTimeCeremony', 'numberOfRefigerators', 'drawn', 'createdAt', 'userId']
      return Couchdb.collection('events').select(select).find(this.eventSelected)
    },
    async getTickets () {
      let tickets = await Couchdb.collection('tickets').where('eventId', this.event._id).get()
      let customers = await this.getCustomersIn(tickets)
      let stocks = await this.getStocksIn(tickets)
      let manufacturers = await this.getManufacturersIn(stocks)
      return this.mappingTickets(tickets, customers, stocks, manufacturers)
    },
    getCustomersIn (tickets) {
      let select = ['_id', 'uc', 'cpf', 'nationalId', 'holder', 'aka', 'phone1', 'address.street', 'address.number', 'address.neighborhood', 'address.city', 'address.zip', 'address.complement', 'observartion', 'nis', 'userId']
      let ticketsCustomersId = tickets.map(item => {
        return item.customerId
      })
      return Couchdb.collection('customers').select(select).whereIn('_id', ticketsCustomersId).get()
    },
    getStocksIn (tickets) {
      let select = ['_id', 'invoice', 'dateInvoice', 'invoicePowerCompany', 'dateInvoicePowerCompany', 'numberOfRefigerators', 'description', 'manufacturerId', 'userId']
      let ticketsSotkcId = tickets.filter(item => {
        return item.stockId !== null
      }).map(item => {
        return item.stockId
      })
      return Couchdb.collection('stocks').select(select).whereIn('_id', ticketsSotkcId).get()
    },
    getManufacturersIn (stocks) {
      let select = ['_id', 'name', 'userId']
      let manufacturersId = stocks.map(item => {
        return item.manufacturerId
      })
      return Couchdb.collection('manufacturers').select(select).whereIn('_id', manufacturersId).get()
    },
    mappingTickets (tickets, customers, stocks, manufacturers) {
      tickets.map(item => {
        item.createdBy = this.usersIdName[item.userId]
        item.customer = customers.find(customer => {
          return customer._id === item.customerId
        })
        if (item.customer) item.customer.createdBy = this.usersIdName[item.customer.userId]
        item.stock = stocks.find(stock => {
          return stock._id === item.stockId
        })
        if (item.stock) item.stock.createdBy = this.usersIdName[item.stock.userId]
        item.manufacturer = manufacturers.find(manufacturer => {
          return item.hasOwnProperty('stock') && item.stock && item.stock.hasOwnProperty('manufacturerId') && manufacturer._id === item.stock.manufacturerId
        })
        if (item.manufacturer) item.manufacturer.createdBy = this.usersIdName[item.manufacturer.userId]
      })
      return tickets
    },
    resetValues () {
      this.event = ''
      this.tickets = []
    },
    addHeaders () {
      let csv = ''
      csv += this.addHeader(this.csvHeaders.customer)
      csv += this.addHeader(this.csvHeaders.ticket)
      csv += this.addHeader(this.csvHeaders.event)
      csv += this.addHeader(this.csvHeaders.stock)
      csv += this.addHeader(this.csvHeaders.manufacturer)
      csv += '\n'
      return csv
    },
    addHeader (headers) {
      let csv = ''
      for (let h in headers) {
        csv += `${headers[h]}${this.csvSeparator}`
      }
      return csv
    },
    addBodies () {
      let csv = ''
      if (this.tickets.length < 1) {
        this.loading = false
        this.$notify({
          message: 'Não há tickets para este evento.',
          type: 'warning'
        })
      } else {
        for (let t in this.tickets) {
          csv += this.addBody(Object.keys(this.csvHeaders.customer), flattenObject(this.tickets[t].customer))
          csv += this.addBody(Object.keys(this.csvHeaders.ticket), flattenObject(this.tickets[t]))
          csv += this.addBody(Object.keys(this.csvHeaders.event), this.event)
          csv += this.addBody(Object.keys(this.csvHeaders.stock), flattenObject(this.tickets[t].stock))
          csv += this.addBody(Object.keys(this.csvHeaders.manufacturer), flattenObject(this.tickets[t].manufacturer))
          csv += '\n'
          let current = parseInt(t) + 1
          this.$emit('progress', { current, total: this.tickets.length })
        }
      }
      return csv
    },

    addBody (keys, obj) {
      let csv = ''
      for (let key of keys) {
        if (!obj || !obj.hasOwnProperty(key) || (key !== 'drawn' && typeof obj[key] === 'undefined')) {
          csv += `"-"${this.csvSeparator}`
          continue
        }

        if ([
          'endDate', 'startDate', 'createdAt', 'dateTimeCeremony', 'documentedAt', 'dateInvoice', 'dateInvoicePowerCompany', 'updatedAt'
        ].indexOf(key) >= 0) {
          csv += obj[key] ? `"${this.$moment(obj[key]).format('L')} ${this.$moment(obj[key])
          .format('LTS')}"${this.csvSeparator}` : `-${this.csvSeparator}`
          continue
        }

        if (obj[key].toString() === 'true' || obj[key].toString() === 'false' || obj[key] === null || key === 'drawn') {
          csv += obj[key] ? `"Sim"${this.csvSeparator}` : `"Não"${this.csvSeparator}`
          continue
        }

        switch (key) {
          case 'checkIn':
            csv += obj[key] ? `"Sim"${this.csvSeparator}` : `"Não"${this.csvSeparator}`
            break
          case 'phone1':
            csv += `"${obj[key]} / ${obj['phone2'] ? obj['phone2'] : '-'}"${this.csvSeparator}`
            break
          default:
            csv += `"${obj[key]}"${this.csvSeparator}`
        }
      }
      return csv
    },

    getReportEvent () {
      let csv = ''
      csv += this.addHeaders()
      csv += this.addBodies()
      let blob = blobUtils.createBlob([csv], { type: 'text/plain' })
      let start = this.$moment(this.event.startDate).format('DD-MM-YYYY')
      let end = this.$moment(this.event.endDate).format('DD-MM-YYYY')
      downloadJs(
        blob,
        `Relatório_Evento_${this.event.city}_${start}_${end}.csv`
      )
    }
  },
  computed: {
    ...mapGetters('users', ['usersIdName'])
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Reports/EventsReport.vue